import Title from './Title'
import classNames from 'classnames'
import { MyContainer } from '~/components/ui/MyContainer'
import styles from './Application.module.css'
import { MyImage } from '~/components/ui/MyImage'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import TabPagination from './TabPagination'

const items = [
  { key: '1', text: '网红打卡地', isLarge: true },
  { key: '2', text: '游乐场', isLarge: false },
  { key: '3', text: '跨界交流', isLarge: false },
  { key: '4', text: '文旅景区', isLarge: true },
  { key: '5', text: '夜市摆摊', isLarge: true },
  { key: '6', text: '展馆展厅', isLarge: false },
  { key: '7', text: '饰品门店', isLarge: false },
  { key: '8', text: '核心商区', isLarge: true },
  { key: '9', text: '照相馆', isLarge: true },
  { key: '10', text: '服装形象店', isLarge: false },
  { key: '11', text: '影视合作', isLarge: false },
  { key: '12', text: '主题公园', isLarge: true },
]

const exampleList = [
  {
    id: '1',
    items: [
      {
        key: '1',
        text: '夜市摆摊',
        url: 'https://cdn.wujiebantu.com/upload/50B09C17B7AE9774ACBD82A331E58C4F/1724984003336/FuPH9UeGkf6KOApo157tvdMh_3rB.jpg',
      },
      {
        key: '2',
        text: '文旅景区',
        url: 'https://cdn.wujiebantu.com/upload/50B09C17B7AE9774ACBD82A331E58C4F/1724985471644/Fn1gYTnU0r_3WC1gMeeCXTy3QEcj.png',
      },
      {
        key: '3',
        text: '展馆展厅',
        url: 'https://cdn.wujiebantu.com/upload/50B09C17B7AE9774ACBD82A331E58C4F/1724983602494/FkY8jpA4jxf-AEhNgh2hTBmI5Fjb.jpg',
      },
      {
        key: '4',
        text: '核心商区',
        url: 'https://cdn.wujiebantu.com/upload/50B09C17B7AE9774ACBD82A331E58C4F/1724984070010/Fo_jSvAoKFR6qzw8_aIL3lfU-pQg.jpg',
      },
    ],
  },
  {
    id: '2',
    items: [
      {
        key: '5',
        text: '影视合作',
        url: 'https://cdn.wujiebantu.com/upload/09AAB6115C3A58EC2FC0C1E1C86EF899/1741681294627/FnQFIKvmZYhDKN0g7nKqBQJsAp_G.jpg',
      },
      {
        key: '6',
        text: '核心商区',
        url: 'https://cdn.wujiebantu.com/upload/09AAB6115C3A58EC2FC0C1E1C86EF899/1741681190345/FlrW1v3OA4y1ji83lMnWqTuXyUXz.jpg',
      },
      {
        key: '7',
        text: '展馆展厅',
        url: 'https://cdn.wujiebantu.com/upload/09AAB6115C3A58EC2FC0C1E1C86EF899/1741681321579/FgkVIZ_vJwv4dhBNqPzxUYXG4dr9.jpg',
      },
      {
        key: '8',
        text: '跨界交流',
        url: 'https://cdn.wujiebantu.com/upload/09AAB6115C3A58EC2FC0C1E1C86EF899/1741681377633/Fj0rI0qqPE7kAeiEO8-rms4pwSzf.jpg',
      },
    ],
  },
]

function Application() {
  return (
    <section className="w-full mt-[64px] ">
      <MyContainer className="!w-[1424px] !pb-[64px]">
        <Title text="适用场景" desc="Applications" />
        <div className="flex mt-6">
          <div className="w-[360px] flex-shrink-0 flex flex-wrap items-center pt-6 pb-6">
            {items.map(ele => (
              <div
                key={ele.key}
                className={classNames(
                  'relative w-[148px] h-[52px] mr-4 last:mr-0',
                  {
                    ['w-[168px] h-[56px]']: ele.isLarge,
                  }
                )}
              >
                <div
                  className={classNames(styles.location, {
                    [styles.large]: ele.isLarge,
                  })}
                >
                  <div className="w-full h-full flex items-center justify-center bg-white font-semibold text-neutral-200 rounded-full px-6 whitespace-nowrap">
                    {ele.text}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="flex-auto" style={{ width: 'calc(100% - 360px)' }}>
            <Swiper
              effect={'coverflow'}
              modules={[Pagination, Autoplay]}
              // hack: 不能为1，为1，loop的时候swiper某些情况下，不会生成下一个slider的预览
              slidesPerView={1.001}
              spaceBetween={24}
              centeredSlides={true}
              loop={true}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: false,
              }}
              autoplay={{
                delay: 3000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
                waitForTransition: true,
              }}
              speed={1000}
            >
              {exampleList.map(example => (
                <SwiperSlide key={example.id} className="px-4 flex flex-wrap">
                  {example.items.map(item => (
                    <div
                      key={item.key}
                      className="w-1/2 px-2 even:pr-0 odd:pl-0"
                    >
                      <div
                        className="w-full h-[245px] rounded-[16px] border-[8px] border-neutral-900"
                        style={{
                          boxShadow: '0px 20px 30px 0px rgba(0, 0, 0, 0.20)',
                        }}
                      >
                        <MyImage
                          tag="v800"
                          className="w-full h-full rounded-[8px] object-cover"
                          src={item.url}
                          lazy={false}
                        />
                      </div>
                      <div className="text-base font-semibold text-neutral-200 mb-2 mt-4 text-center">
                        {item.text}
                      </div>
                    </div>
                  ))}
                </SwiperSlide>
              ))}
              <TabPagination
                cases={exampleList}
                className="!px-0 !justify-center !bottom-0"
              />
            </Swiper>
          </div>
        </div>
      </MyContainer>
    </section>
  )
}

export default Application
